

'use strict';

var jquery = require('jquery');
var RouletteCube = require('./nameRouletteCube');


var NameRoulette = function($baseElem, onSpinCallback) {
    this.$baseElem = $baseElem;
    this.onSpinCallback = onSpinCallback;

    this.data = {
        a: ['Sacred', 'Salty', 'Sandy', 'Sassy', 'Satirical', 'Savory', 'Scary', 'Sci-fi', 'Scratchy', 'Scrawny', 'Secret', 'Sedated', 'Seedless', 'Semi', 'Sensible', 'Sensitive', 'Sensual', 'Serious', 'Seriously', 'Seven', 'Seventy', 'Several', 'Sexy', 'Shaggy', 'Shakespearean', 'Shaved', 'Shaving', 'Shotgun', 'Shy', 'Sick', 'Singing', 'Single', 'Sinister', 'Six', 'Sixty', 'Sizable', 'Skilled', 'Skillful', 'Skimpy', 'Slightly', 'Slippery', 'Slow', 'Small', 'Smelly', 'Smokey', 'Smooth', 'Snowy', 'Soapy', 'Sober', 'Social', 'Some', 'Somewhat', 'Space', 'Speedy', 'Spicy', 'Squashy', 'Squishy', 'Sticky', 'Stolen', 'Stylish', 'Sub', 'Subtle', 'Suitably', 'Super', 'Supportive', 'Surprising', 'Suspicious', 'Sweaty', 'Sweet', 'Swift', 'Symbiotic', 'Synthetic', 'Systematic', 'Systematically'],

        b: ['Machine', 'Macho', 'Mad', 'Mafia', 'Male', 'Malicious', 'Mammoth', 'Mango', 'Manmade', 'Mariachi', 'Market', 'Massive', 'Master', 'Meat', 'Meaty', 'Mecha', 'Mechanical', 'Medium', 'Mega', 'Mental', 'Mentholated', 'Metal', 'Micro', 'Microwaveable', 'Middle', 'Midget', 'Mighty', 'Milky', 'Million', 'Mini', 'Minimum', 'Mining', 'Missing', 'Misused', 'Mobile', 'Monster', 'Monstrous', 'Moon', 'Morbidly', 'Motorcycle', 'Motorized', 'Mountain', 'Moving', 'Muppet', 'Mushy', 'Mutant', 'Mutated', 'Mythical'],

        c: ['Games', 'Gang', 'Gangs', 'Gangsters', 'Gardeners', 'Gardens', 'Gasses', 'Gathering', 'Gears', 'Geckos', 'Geishas', 'Genomes', 'Gentlemen', 'Gerbils', 'Gestures', 'Ghetto', 'Ghettos', 'Ghosts', 'Giant', 'Giants', 'Gibbons', 'Giblets', 'Gingers', 'Giraffes', 'Glitches', 'Gloves', 'Glue', 'Gnomes', 'Goats', 'God', 'Goo', 'Goods', 'Goons', 'Gophers', 'Gorillas', 'Goulash', 'Graffiti', 'Grandmas', 'Grandpas', 'Greatness', 'Greetings', 'Gremlins', 'Grenades', 'Grills', 'Grizzly Bear', 'Grooves', 'Grumbles', 'Guacamole', 'Guardians', 'Guards', 'Guests', 'Guilds', 'Guitarists', 'Gulls', 'Gun', 'Guns']
    };

    this.cubes = [];

    this.configureRouletteCubes();
    this.configureEvents();
};

NameRoulette.prototype = {
    constructor: NameRoulette,

    configureRouletteCubes: function() {
        // console.log('loop through cube children and instantiate RouletteCube instance');
        var cubes = this.cubes;
        var dataList = this.data;
        var callback = (this.onSpinCallback) ? this.onSpinCallback : null;

        this.$baseElem.find('[data-cube]').each(function() {
            var $elem = $(this);
            var dataKey = $elem.attr('data-cube');

            cubes.push(
                new RouletteCube( $elem, dataList[dataKey], callback )
            );
        });
    },

    spinAll: function() {
        this.cubes.forEach(function(item) {
            item.randomSpin();
        });

        if (this.onSpinCallback) {
            this.onSpinCallback();
        }
    },

    onBaseClick: function() {
        // console.log('on name roulette click');
        // this.spinAll();
    },

    configureEvents: function() {
        // this.$baseElem.on( 'click', this.onBaseClick.bind(this) );
    }
};


module.exports = NameRoulette;




/*****************
 ** WEBPACK FOOTER
 ** ./dev/js/src/name-roulette/nameRoulette.js
 ** module id = 6
 ** module chunks = 0
 **/